import { Alert, Button, Card, Checkbox, Form, Input, Select } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import sspApi from 'src/component/app/ssp/SspApi'
import { uuidV4 } from 'src/util/Util'
import { SspBean } from '../../../api/api'
import { FormDataType, formDataLoader } from '../../../util/FormDataLoader'

const FormItem = Form.Item
const Option = Select.Option

const formInfoItems: FormDataType[] = [
    FormDataType.Countries,
]

export const billingTypeName = (type: string) => {
    switch (type) {
        case 'Adm': return 'Adm (Script)'
        case 'AdmImage': return 'Adm (Image)'
        default: return type
    }
}

const SspCreate = () => {

    const [info, setInfo] = useState({
        countries: [],
    })

    const [error, setError] = useState(undefined)
    const [form] = Form.useForm()

    const navigateTo = useNavigate()

    const loadData = async () => {
        try {
            const resp = await formDataLoader(...formInfoItems)
            setInfo(resp as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await sspApi.create(values)
            navigateTo('/ssp')
        } catch (e) {
            setError(e.error)
        }
    }

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
    >
        {error && <Alert message={error} type="error" />}
        <Card title="SSP" size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
                rules={[{ required: true, message: 'SSP name required' }]}
            >
                <Input placeholder="Name" />
            </FormItem>
            <FormItem
                required
                name="endpoint"
                label="Endpoint"
                rules={[{ required: true, message: 'SSP endpoint required' }]}
            >
                <Input placeholder="Endpoint" />
            </FormItem>
            <FormItem
                required
                name="sspType"
                label="SSP Type"
                rules={[{ required: true, message: 'SSP type required' }]}
            >
                <Select placeholder="Select SSP Type">
                    {Object.values(SspBean.SspTypeEnum).map(type => <Option key={type} value={type}>{type}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                required
                name="billingType"
                label="Billing Type"
                rules={[{ required: true, message: 'SSP billing type required' }]}
            >
                <Select placeholder="Select Billing Type">
                    {Object.values(SspBean.BillingTypeEnum).map(type => <Option key={type} value={type}>{billingTypeName(type as string)}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="apiKey"
                label="API key"
            >
                <Input placeholder="Generate API key" addonAfter={<Button size="small" type="text" onClick={() => form.setFieldValue('apiKey', uuidV4())}>Generate</Button>} />
            </FormItem>
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                initialValue="true"
            >
                <Checkbox />
            </FormItem>
            <FormItem
                name="consentValidation"
                label="TCF check"
                valuePropName="checked"
            >
                <Checkbox />
            </FormItem>
            <FormItem
                name="linkByDefault"
                label="Link by Default"
                valuePropName="checked"
            >
                <Checkbox />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Create</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/ssp')}>Cancel</Button>
        </div>
    </Form>
}

export default SspCreate


// WEBPACK FOOTER //
// ./src/component/app/ssp/SspCreate.tsx